function valueFormat(InputComponents) {
  return {
    model: {
      event: 'change'
    },
    props: {
      parser: { type: [Array, Function] },
      formatter: { type: Function },
      value: { validator() { return true; } },
      options: { type: Object, default: () => { return {}; } }
    },
    data() {
      let { input = true, enter = true, blur = true } = this.$props.options;

      let value = this.$props.value;

      const { parser, formatter } = this.$props;

      if (formatter) {
        value = formatter(value);
      }

      if (parser && Array.isArray(parser) && parser.length) {
        parser.forEach(rule => {
          if (rule.parser) value = rule.parser(value);
        });
      } else if (parser) {
        value = parser(value);
      }

      if (formatter) {
        value = formatter(value);
      }

      return {
        curValue: value,
        input,
        enter,
        blur
      };
    },
    methods: {
      onKeyDown(e) {
        const { parser, formatter } = this;
        let value = this.curValue;
        if (e.keyCode === 13) {
          if (parser && Array.isArray(parser) && parser.length) {
            parser.forEach(rule => {
              const en = rule.options ? rule.options.enter : this.enter;
              if (en && rule.parser) {
                value = rule.parser(value);
              }
            });
          } else if (this.enter && parser) {
            value = parser(value);
          }
          let newCurValue = value;
          if (formatter) newCurValue = formatter(value);
          if (value !== this.value || (value === this.value && this.curValue !== newCurValue)) {
            this.curValue = newCurValue;
            this.$emit('change', value);
          }
        }

        this.$emit('keydown', e);
      },
      onInput(value) {
        let oldValue = value;
        const { parser, formatter } = this;
        if (parser && Array.isArray(parser) && parser.length) {
          parser.forEach(rule => {
            const inpt = rule.options ? rule.options.input : this.input;
            if (inpt && rule.parser) value = rule.parser(value);
          });
        } else if (parser) {
          value = parser(value);
        }

        if (formatter) {
          value = formatter(value);
        }

        if (value !== oldValue && this.curValue === value) {
          this.$refs.refInputElm.forceUpdateCurValue(value);
        } else {
          this.curValue = value;
          this.$emit('input', this.curValue);
        }
      },
      onBlur(e) {
        const { parser, formatter } = this;
        let value = this.curValue;

        if (parser && Array.isArray(parser) && parser.length) {
          parser.forEach(rule => {
            const b = rule.options ? rule.options.blur : this.blur;
            if (b && rule.parser) value = rule.parser(value);
          });
        } else if (this.blur && parser) {
          value = parser(value);
        }

        let newCurValue = value;
        if (formatter) newCurValue = formatter(value);
        if (value !== this.value || (value === this.value && this.curValue !== newCurValue)) {
          this.curValue = newCurValue;
          this.$emit('change', value);
        }

        this.$emit('blur', e);
      }
    },
    render(h) {
      const {
        keydown,
        blur,
        input,
        change,

        ...othersEvent
      } = this.$listeners;

      return h(InputComponents, {
        on: {
          keydown: this.onKeyDown,
          blur: this.onBlur,
          input: this.onInput,
          ...othersEvent
        },
        props: {
          ...this.$attrs,
          value: this.curValue
        },

        scopedSlots: {
          ...this.$scopedSlots
        },

        ref: 'refInputElm'
      });
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (this.formatter) value = this.formatter(value);
          this.curValue = value;
        }
      }
    }
  };
}

export default valueFormat;
